import {
  BulkActionContainerCol,
  Button,
  Col,
  PlusIcon,
  RemoveIcon,
  Table,
  TableActionBarRow,
} from "melco-ui";

import { useTranslation } from "react-i18next";
import {
  BulkActionCount,
  FormattedDate,
  ReportingMelcoMachineStatisticsModelsMachineListItem,
  Search,
  useTableSelection,
} from "melco-shared-logic";
import { BulkActionAddMachine } from "./BulkActionAddMachine";
import { useAddRemoveMachine } from "../../../hooks/reporting/useAddRemoveMachine";
import { useMachines } from "../../../hooks/reporting/useMachines";
import { useEffect, useState } from "react";

export type AddMachineListProps = {};

export const AddMachineList: React.FC<AddMachineListProps> = ({}) => {
  const { t } = useTranslation();

  const {
    data,
    pagination,
    isLoading,
    onTableConfigChange,
    searchQueryChange,
  } = useMachines();

  const [machinesToDisplay, setMachinesToDisplay] = useState<
    ReportingMelcoMachineStatisticsModelsMachineListItem[] | undefined
  >(undefined);

  useEffect(() => {
    let machines = data?.filter((d) => !d.is_discontinued);
    setMachinesToDisplay(machines);
  }, [data]);

  const { isAlreadyAdded, addMachines, removeMachines } = useAddRemoveMachine();

  const columns = [
    {
      title: t("reporting.machines.list.columns.serial_number"),
      key: "serial_number",
      dataIndex: "serial_number",
      sorter: true,
    },
    {
      title: t("reporting.machines.list.columns.name"),
      key: "name",
      dataIndex: "name",
      sorter: true,
    },
    {
      title: t("reporting.machines.list.columns.registered"),
      key: "registered_date",
      //dataIndex: "registered_date",
      sorter: true,
      render: (item: ReportingMelcoMachineStatisticsModelsMachineListItem) => (
        <FormattedDate date={item.registered_date} />
      ),
    },
    {
      title: t("reporting.machines.list.columns.last_sync"),
      key: "last_sync_date",
      //dataIndex: "last_sync_date",
      sorter: true,
      render: (item: ReportingMelcoMachineStatisticsModelsMachineListItem) => (
        <FormattedDate date={item.last_sync_date} />
      ),
    },
    {
      title: "",
      render: (
        rowObj: ReportingMelcoMachineStatisticsModelsMachineListItem
      ) => {
        return isAlreadyAdded(rowObj) ? (
          <Button
            icon={<RemoveIcon />}
            onClick={() => removeMachines([{ device_id: rowObj.device_id! }])}
          >
            {t("reporting.machines.list.columns.remove")}
          </Button>
        ) : (
          <Button
            type="primary"
            icon={<PlusIcon />}
            onClick={() => addMachines([rowObj])}
          >
            {t("reporting.machines.list.columns.add")}
          </Button>
        );
      },
    },
  ];

  const { selectedRowKeys, setSelectedRowKeys, rowSelection, onRow } =
    useTableSelection<any>(() => {});

  return (
    <>
      <TableActionBarRow>
        <Col>
          <Search
            onSearchInputChange={(query: string) => searchQueryChange(query)}
          />
        </Col>
        <BulkActionContainerCol>
          <BulkActionCount selectedCount={selectedRowKeys.length} />
          <BulkActionAddMachine
            allMachine={machinesToDisplay ?? []}
            selectedRowKeys={selectedRowKeys}
            setSelectedRowKeys={setSelectedRowKeys}
          />
        </BulkActionContainerCol>
      </TableActionBarRow>
      <Table
        dataSource={machinesToDisplay}
        columns={columns}
        rowKey="device_id"
        onChange={onTableConfigChange}
        pagination={pagination}
        onRow={onRow}
        rowSelection={rowSelection}
        loading={isLoading}
      />
    </>
  );
};
